// TODO: This is a temporary solution for https://linear.app/indyriot/issue/RIOT-204
export const replaceUsernameNumbers = (username) => {
  return username.replace(/-\d{1,2}/, '')
}
